import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { persistStore, persistReducer } from 'redux-persist'
import { routerMiddleware } from 'connected-react-router'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import storage from 'redux-persist/lib/storage'
import createSagaMiddleware from 'redux-saga'
import { createBrowserHistory } from 'history'

import createRootReducers from './rootReducers'
import rootSaga from './rootSagas'

const history = createBrowserHistory()

const persistConfig = {
  storage,
  key: `${process.env.REACT_APP_SERVICE}_storage`,
  stateReconciler: autoMergeLevel2,
  whitelist: ['auth', 'token', 'signature', 'desktop'],
}

const sagaMiddleware = createSagaMiddleware()
const router = routerMiddleware(history)
const middlewares = [router, sagaMiddleware]

const persistedReducer = persistReducer(persistConfig, createRootReducers(history))
const store = createStore(
  persistedReducer,
  process.env.NODE_ENV === 'development'
    ? composeWithDevTools(applyMiddleware(...middlewares))
    : applyMiddleware(...middlewares),
)

const persistor = persistStore(store)
sagaMiddleware.run(rootSaga)

export { store, persistor, history }
